export default __webpack_public_path__ + "static/media/Flowers04.da1ae06e.jpg";